import { can, type AuthorizedUser } from '@dma/auth';
import { AuthorizationError, ApplicationError, type Logger } from '@dma/shared';
import type { ScientificEntryRepository } from '../../domain/repositories/ScientificEntryRepository.interface';

export class DeleteScientificEntryUseCase {
  constructor(
    private readonly repository: ScientificEntryRepository,
    private readonly logger: Logger
  ) {}

  public async execute(actingUser: AuthorizedUser | null, id: string): Promise<void> {
    if (!can(actingUser, 'scientific-entry:manage')) {
      throw new AuthorizationError();
    }

    try {
      await this.repository.delete(id);
    } catch (error) {
      this.logger.error('Failed to delete scientific entry', {
        entryId: id,
        cause: error instanceof Error ? error.message : String(error)
      });
      throw new ApplicationError('SCIENTIFIC_ENTRY_DELETE_FAILED', 'حذف مطلب با مشکل مواجه شد. لطفاً دوباره تلاش کنید.', {
        cause: error
      });
    }
  }
}
